<ul *ngIf="pager.pages && pager.pages.length" class="pagination">
  <li *ngIf="currentPage > 1" class="prev">
    <a
      [queryParams]="pager.prevPage.queryParams"
      [routerLink]="pager.prevPage.routerLink"
    >
      <span class="small-label">&lt;&lt;</span>
      <span class="full-label">&lt;&lt; Föregående</span>
    </a>
  </li>
  <span *ngIf="currentPage === pager.totalPages"></span>
  <li
    *ngFor="let page of pager.pages; trackBy: pagerTrackBy"
    [ngClass]="{ 'active': currentPage === page.pageNumber }"
    class="page"
  >
    <a
      [queryParams]=" page.link.queryParams
  "
      [routerLink]="page.link.routerLink"
    >{{ page.pageNumber }}</a
    >
  </li>
  <span *ngIf="currentPage === 1"></span>
  <li *ngIf="currentPage < pager.totalPages" class="next">
    <a
      [queryParams]="pager.nextPage.queryParams"
      [routerLink]="pager.nextPage.routerLink"
    >
      <span class="small-label">&gt;&gt;</span>
      <span class="full-label">Nästa &gt;&gt;</span>
    </a>
  </li>
</ul>
